import React, { useState,  useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import {  FaExclamationCircle,FaPaperclip } from 'react-icons/fa';
import FloatingLabelInputAutoComplete from '../../ui/FloatingLabelInputAutoComplete';
import FloatingLabelSelect from '../../ui/FloatingLabelSelect';
import { getTeleVerificationListByFilters, fetchSubClientData, downloadCustomerFinalPdf, loadOptions } from '../../../services/client/customerApiService';
import { fetchServiceTypeData } from '../../../services/client/serviceTypeApiService';
import DynamicForm from './DynamicForm';
import UpdateVerification from './UpdateVerification';
import CustomRichTable from '../../common/CustomRichTable';

const TeleVerificationList = () => {
    const bgColorMapping = {
        Pending: "#FDE8E4",
        Completed: "#DAF4F0",
        Process: "#FEF4E4"
      };
      const textColorMapping = {
        Pending: "#F05648",
        Completed: "#0AB39C",
        Process: "#F78848"
      };
    const [loading, setLoading] = useState(false);
    const [apiResponse, setApiResponse] = useState(null);
    const [formValues, setFormValues] = useState({
        clientId: '',
        serviceTypeId: '',
        subClientId: '',
        checkinId: '',
        status:-1
    });
    const [subClients, setSubClients] = useState([]);
    const [serviceTypes, setServiceTypes] = useState([]);
    const [errors, setErrors] = useState({});
    const [customerFiles, setCustomerFiles] = useState([]);
    const [selectedTask, setSelectedTask] = useState(null); // State for selected task
    const [component, setComponent] = useState(null);
    const navigate = useNavigate(); // Initialize useNavigate
    const [suggestions, setSuggestions] = useState([]);
    const [suggestionsLoading, setSuggestionsLoading] = useState(false);
    const inputClasses = (field) => (errors[field] ? 'border-red-500' : 'border-gray-300');
    const statusList = [{'label':'All','value': -1},
                        {'label':'Pending','value': 0},
                        {'label':'Process','value': 1},
                        {'label':'Completed','value': 2}
                        ]
    useEffect(() => {
        const fetchServiceTypeByClient = async () => {
            try {
                const data = await fetchServiceTypeData(localStorage.getItem('clientID'));
                setServiceTypes(data.map(obj => ({ value: obj.serviceTypeId, label: obj.serviceType })));
            } catch (error) {
                console.error("Error fetching service types:", error);
            }
        };
        fetchServiceTypeByClient();
    }, []);

    useEffect(() => {
        const getSubClients = async () => {
            try {
                const subClientData = await fetchSubClientData(localStorage.getItem('clientID'));
                setSubClients(subClientData.map(subClient => ({
                    value: subClient.subClientId,
                    label: subClient.subClientName
                })));
            } catch (error) {
                console.error("Error fetching sub-clients:", error);
            }
        };
        getSubClients();
    }, []);

    const validate = () => {
        const newErrors = {};
        //if (!formValues.checkinId) newErrors.checkinId = 'Checkin ID Required!';
        return newErrors;
    };

    // Handle the change in the input field
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormValues((prev) => ({ ...prev, [name]: value }));

        // Trigger fetch if input length is at least 3 characters
        if (value.length >= 3) {
            fetchSuggestions(value);
        } else {
            setSuggestions([]); // Clear suggestions if input is less than 3 characters
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = validate();
        if (Object.keys(validationErrors).length === 0) {
            setLoading(true);
            try {
                // Manually add the clientId here instead of relying on the setFormValues update
                const updatedFormValues = { ...formValues, clientId: localStorage.getItem('clientID') };

                //console.log(updatedFormValues); // You should see the clientId now included here
                const data = await getTeleVerificationListByFilters(updatedFormValues);
                if (data.success && data.success.length > 0) {
                    const resultData = data.success;
                    const updatedData = resultData.map(item => {
                        let status = '';
                        switch(item.status) {
                          case 0:
                            status = 'Pending';
                            break;
                          case 1:
                           status = 'Process';
                            break;
                          case 2:
                            status = 'Completed';
                            break;
                            case 3:
                              status = 'Approved';
                              break;  
                          default:
                            status = '---';
                        }
                        return {
                          ...item,
                          status
                        };
                      });
                      setCustomerFiles(updatedData);
                    setApiResponse({ success: 'Files fetched successfully!' });
                } else {
                    setCustomerFiles([]);
                    setApiResponse({ error: 'No Data Found' });
                }
            } catch (error) {
                console.error("Submission failed:", error);
                setApiResponse({ error: 'Failed to submit form. Please try again.' });
                setCustomerFiles([]);
            } finally {
                setLoading(false);
                setErrors(validationErrors);
            }
        } else {
            setErrors(validationErrors);
        }
    };



    const resetFormValues = () => {
        setFormValues({
            serviceTypeId: '',
            subClientId: '',
            checkinId: '',
            status:-1
        });
        setErrors({});
    };

    const handleCancel = () => {
        resetFormValues();
        navigate('/televerificationlist');
    };
    const handleFormSubmit = (data) => {
        setSelectedTask(null);
        setCustomerFiles([]);
    };
    if (selectedTask) {
        if (component === "TELE_VERIFY") {
            return <DynamicForm fileId={selectedTask.fileDetailsId} onSubmit={handleFormSubmit} selectedFileDetails={selectedTask} />;
        } else {
            return <UpdateVerification fileId={selectedTask.fileDetailsId} onSubmit={handleFormSubmit} selectedFileDetails={selectedTask} />;
        }
    }

    // Fetch suggestions from the server
    const fetchSuggestions = async (inputValue) => {
        setSuggestionsLoading(true); // Set loading to true
        try {
            const data = await loadOptions(inputValue);
            const suggestionsData = data.map((item) => ({ label: item, value: item }));
            setSuggestions(suggestionsData);
        } catch (error) {
            console.error('Error fetching suggestions:', error);
        } finally {
            setSuggestionsLoading(false); // Set loading to false after fetching
        }
    };

    // Handle when a user selects a suggestion
    const handleSelectSuggestion = (suggestion) => {
        setFormValues((prev) => ({ ...prev, checkinId: suggestion.label }));
        setSuggestions([]); // Clear suggestions after selection
    };
const columns = [
        { Header: 'Client', accessor: 'subClientName' },
        { Header: 'Checkin ID', accessor: 'checkinId' },
        { Header: 'Applicant', accessor: 'customerName' },
        //{ Header: 'Address', accessor: 'address' },
        { Header: 'Component', accessor: 'componentName' },
        {
            Header: 'Attachment',
            Cell: ({ row }) => (
                <p>
                    {row.attachmentUrl ? (
                        <a 
                            href={row.attachmentUrl} 
                            target="_blank" 
                            rel="noopener noreferrer"
                            style={{ textDecoration: "none" }}
                        >
                            <FaPaperclip />
                        </a>
                    ) : (
                        ""
                    )}
                </p>
            ),
        },
        
        { Header: 'Executive', accessor: 'fieldOfficerName' },
        
        { Header: 'Date', accessor: 'createdDate' },
        {
          Header: 'Status',
          Cell: ({ row }) => (
            <p class={`px-2 py-1 w-fit rounded-md text-[9.75px] leading-[9.26px] font-semibold text-[#495057] 
                      text-[${textColorMapping[row.status]}] bg-[${bgColorMapping[row.status]}]`}>
              {row.status}
            </p>
          ),
        },
        {
            Header: 'Form',
            Cell: ({ row }) => (
                <button className="mt-4 text-white bg-blue-500 hover:bg-blue-700 px-4 py-2 rounded-full" onClick={() => {
                    setSelectedTask(row)
                        ; setComponent(row.componentName);
                }
                }>Form</button>
            ),
          },
        
      ];
    return (
        <div className="container mx-auto p-6 bg-white rounded-lg border">
            <form onSubmit={handleSubmit} className="space-y-6 w-full">
                <h1>Assigned Components List</h1>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <div>
                        {loading ? (
                            <p>Loading Service Types...</p>
                        ) : (
                            <FloatingLabelSelect
                                label="Select Service Type"
                                id="serviceTypeId"
                                name="serviceTypeId"
                                value={serviceTypes.find(st => st.value === formValues.serviceTypeId) || null}
                                onChange={(option) => setFormValues({ ...formValues, serviceTypeId: option.value })}
                                className={inputClasses('serviceTypeId')}
                                options={serviceTypes}
                                isSearchable={true}
                            />
                        )}
                    </div>
                    <div>
                        <FloatingLabelSelect
                            label="Select Client"
                            id="subClientId"
                            name="subClientId"
                            value={subClients.find(subClient => subClient.value === formValues.subClientId) || null}
                            onChange={(option) => setFormValues({ ...formValues, subClientId: option.value })}
                            className={inputClasses('subClientId')}
                            options={subClients}
                            isSearchable={true}
                        />
                    </div>
                    <div>
                        <FloatingLabelInputAutoComplete
                            label="Checkin ID"
                            id="checkinId"
                            name="checkinId"
                            value={formValues.checkinId}
                            onChange={handleChange}
                            autocomplete="off" // Disable browser autocomplete
                            suggestions={suggestions}
                            onSelectSuggestion={handleSelectSuggestion}
                            loading={suggestionsLoading} // Pass loading state to the input
                            className="mb-4"
                        />
                        
                    </div>
                    <div>
                        <FloatingLabelSelect
                            label="Select Status"
                            id="component_status"
                            name="component_status"
                            value={statusList.find(componentStatus => componentStatus.value === formValues.status) || null}
                            onChange={(option) => setFormValues({ ...formValues, status: option.value })}
                            options={statusList}
                            isSearchable={true}
                        />
                    </div>
                </div>

                <div className="flex gap-4">
                    <button
                        type="submit"
                        className={`px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 ${loading ? 'opacity-50' : ''}`}
                        disabled={loading}
                    >
                        {loading ? 'Searching...' : 'Search'}
                    </button>
                    <button
                        id="filterButton"
                        type="button"
                        onClick={handleCancel}
                        className="px-4 py-2 bg-gray-500 text-white rounded-md hover:bg-gray-600"
                    >
                        Cancel
                    </button>
                </div>

                {apiResponse && (
                    <motion.div
                        className={`mt-4 flex items-center ${apiResponse.error ? 'text-red-500' : 'text-green-500'}`}
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5 }}
                    >
                        {apiResponse.error ? (
                            <>
                                <FaExclamationCircle className="mr-2" />
                                {apiResponse.error}
                            </>
                        ) : ''
                            // (
                            //     <>
                            //         <FaCheckCircle className="mr-2" />
                            //         {apiResponse.success}
                            //     </>
                            // )
                        }
                    </motion.div>
                )}
            </form>
            <div>
                {customerFiles.length === 0 ? (
                    <p></p>
                ) : (
                    /*<div className="overflow-x-auto">
                        <table className="min-w-full table-auto">
                            <thead>
                                <tr className="bg-gradient-to-r from-indigo-600 to-indigo-500 text-white shadow-md">
                                    <th className="px-2 py-3 text-xs md:text-sm font-semibold">Client</th>
                                    <th className="px-2 py-3 text-xs md:text-sm font-semibold">Checkin ID</th>
                                    <th className="px-2 py-3 text-xs md:text-sm font-semibold">Applicant</th>
                                    <th className="px-2 py-3 text-xs md:text-sm font-semibold">Address</th>
                                    <th className="px-2 py-3 text-xs md:text-sm font-semibold">Assigned To</th>
                                    <th className="px-2 py-3 text-xs md:text-sm font-semibold">Verification Type</th>
                                    <th className="px-2 py-3 text-xs md:text-sm font-semibold">Status</th>
                                    <th className="px-2 py-3 text-xs md:text-sm font-semibold">Edit</th>
                                </tr>
                            </thead>
                            <tbody>
                                {customerFiles.map((task, index) => (
                                    <tr key={task.taskId} className={`transition-all duration-300 ease-in-out 
                    ${index % 2 === 0 ? 'bg-white' : 'bg-gray-50'} 
                    hover:bg-blue-50 hover:shadow-lg`}>
                                        <td className="border px-4 py-2 text-xs md:text-sm">{task.subClientName}</td>
                                        <td className="border px-4 py-2 text-xs md:text-sm">{task.checkinId}</td>
                                        <td className="border px-4 py-2 text-xs md:text-sm">{task.customerName}</td>
                                        <td className="border px-4 py-2 text-xs md:text-sm">{task.address}</td>
                                        <td className="border px-4 py-2 text-xs md:text-sm">{task.fieldOfficerName}</td>
                                        <td className="border px-4 py-2 text-xs md:text-sm">{task.componentName}</td>
                                        <td className="border px-4 py-2 text-xs md:text-sm">{task.status}</td>
                                        <td className="border px-4 py-2 text-xs md:text-sm">
                                            <button className="mt-4 text-white bg-blue-500 hover:bg-blue-700 px-4 py-2 rounded-full" onClick={() => {
                                                setSelectedTask(task)
                                                    ; setComponent(task.componentName);
                                            }
                                            }>Form</button>
                                        </td>


                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
*/
<CustomRichTable columns={columns} data={customerFiles}/>
                )}
            </div>
        </div>
    );
};




export default TeleVerificationList;

